import { apply, toast } from '../core/effects';
import { S } from '../core/game';
import { m } from '../i18n';
import { objName } from '../i18n/labels';
import { sfx } from '../audio/sfx';
import { say, type Choice } from '../ui/dialog';
import { useToilet } from './interactions';
import { isVehicle, riding, type Ride } from './places';
import { registerObjectPrefix } from './registry';

/**
 * Shared city services: rent-a-ride shops (`rent_*`) and public toilets (`wc_*`).
 * Any map can place one; the id prefix is all that matters.
 */

type Vehicle = 'bike' | 'kick' | 'ebike';
const PRICE: Record<Vehicle, number> = { bike: 5, kick: 8, ebike: 15 };

function rentShop(): void {
  const t = m().airport.rent;
  const who = objName('rent_shop');
  const on = riding.on;
  const choices: Choice[] = [];
  if (isVehicle(on)) choices.push({ text: t.ret, run: () => ((riding.on = null), sfx('pop'), toast(t.returned)) });
  else {
    for (const v of ['bike', 'kick', 'ebike'] as Vehicle[]) {
      choices.push({
        text: t[v],
        cost: t.price(PRICE[v]),
        run: () => {
          if (S().coins < PRICE[v]) return toast(t.poor);
          apply({ coins: -PRICE[v] }, { float: false });
          riding.on = v as Ride;
          sfx('ok');
          toast(t.rented(t.names[v]));
          if (v === 'ebike') window.setTimeout(() => toast(t.helmet), 900);
        },
      });
    }
  }
  choices.push({ text: m().common.back });
  say({ who, icon: '🛴', text: `${t.text}\n${t.rule}`, choices });
}

function toilet(): void {
  const t = m().airport.wc;
  say({
    who: objName('wc_public'),
    icon: '🚻',
    text: t.text,
    choices: [
      { text: t.use, run: useToilet },
      { text: t.wash, run: () => (sfx('water'), apply({ mood: 1, minutes: 1 }, { float: false })) },
      { text: m().common.back },
    ],
  });
}

registerObjectPrefix('rent_', rentShop);
registerObjectPrefix('wc_', toilet);
